// USING AND ONLINE MINIFIER AND PASTING THIS IN bundle.js
// https://skalman.github.io/UglifyJS-online/

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
var scrolledPastThreshold = false;
var shopMenuOpen = false;
//NAV EXTERNAL LINKS NEW TAB
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = "_blank";
		links[i].rel = "noreferrer noopener";
	}
}
//CUSTOM SELECT
$(".custom-select").parent().addClass("select-wrap");
if ($(".add-to-cart-stalker-wrap").length) {
	$(".custom-select")
		.select2({
			minimumResultsForSearch: Infinity,
			width: "resolve",
		})
		.on("select2:opening", function (e) {
			if(e.currentTarget[0].attributes.name){
				if (e.currentTarget[0].attributes.name.value == "Size") {
					$("body").addClass("has-size-dropdown-open");
				} else {
					$("body").removeClass("has-size-dropdown-open");
				}
				if (e.currentTarget[0].attributes.name.value == "Color") {
					$("body").addClass("has-color-dropdown-open");
				} else {
					$("body").removeClass("has-color-dropdown-open");
				}
			} else if (e.currentTarget[0].hasAttribute("data-size")){
				$("body").addClass("has-size-dropdown-open");
			} else {
				$("body").removeClass("has-size-dropdown-open");
			}
		})
		.on("select2:select", function (e) {
			$("body").removeClass("has-size-dropdown-open");
			if(e.currentTarget[0].attributes.name){
				if (e.currentTarget[0].attributes.name.value == "Color") {
					$(".pdp-color").text(e.currentTarget.value);
				}
			}
		})
		.on("select2:close", function (e) {
			$("body").removeClass("has-size-dropdown-open");
		});
} else if (!isMobile) {
	$(".custom-select").each(function() {
		const $select = $(this);
		const isInDrawer = $select.closest('drawer-ui').length > 0;
		
		const config = {
			minimumResultsForSearch: Infinity,
		};
		
		// If select is inside a drawer, set dropdownParent to the drawer
		if (isInDrawer) {
			config.dropdownParent = $select.closest('drawer-ui');
		}
		
		$select.select2(config);
	})
	.on("select2:opening", function (e) {
		$("body").addClass("select-open");
		e.currentTarget[0].closest(".select-wrap").classList.add("select-open");	
	})
	.on("select2:open", function (e) {
		if($(".quick-buy-form").length){
			$(".quick-buy-form").removeClass("dropdown-active");
		}
		$("body > .select2-container").attr("id", `dropdown-${e.currentTarget[0].parentElement.id}`)
		$("body > .select2-container").on("mouseover", function(){
			if(e.currentTarget[0].parentElement.closest(".shop-grid-item") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item").classList.contains("quick-shop-active")){
				$(`#${e.currentTarget[0].parentElement.id}`).parents("form").addClass("dropdown-active")
			}
			if(e.currentTarget[0].parentElement.closest(".shop-grid-item-v2") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item-v2").classList.contains("quick-shop-active")){
				$(`#${e.currentTarget[0].parentElement.id}`).parents("form").addClass("dropdown-active")
			}
			if($(".quick-buy-form").length){
				$(e.currentTarget).children().each(function(index){
					if($(this)[0].hasAttribute("data-disabled")){
						$(`#select2-${e.currentTarget[0].parentElement.id}-results li`).eq(index).addClass("select2-results__option--disabled")
					}
				})
			}
		}).on("mouseleave", function(){
			if(e.currentTarget[0].parentElement.closest(".shop-grid-item") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item").classList.contains("quick-shop-active")){
				$(`#${e.currentTarget[0].parentElement.id}`).parents("form").removeClass("dropdown-active")
				$(".custom-select").select2('close');
			}
			if(e.currentTarget[0].parentElement.closest(".shop-grid-item-v2") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item-v2").classList.contains("quick-shop-active")){
				$(`#${e.currentTarget[0].parentElement.id}`).parents("form").removeClass("dropdown-active")
				$(".custom-select").select2('close');
			}
		})
		e.currentTarget[0].closest(".select-wrap").classList.add("select-open");
	})	
	.on("select2:selecting", function (e) {
		$("body").addClass("select-open");
		e.currentTarget[0].closest(".select-wrap").classList.add("select-open");
	})
	.on("select2:select", function (e) {
		$("body").removeClass("select-open");
		if($(".quick-buy-form").length){
			$(".quick-buy-form").removeClass("dropdown-active");
			var $select = $(e.currentTarget);
			var selectedValue = e.currentTarget.value;
			var selectedSize = $select.find(`option[value="${selectedValue}"]`).attr("data-size");
			$(".quick-buy-form").each(function(){
				var $form = $(this);
				var selectedSizeOptionEl = $form.find(`option[data-size="${selectedSize}"]`);
				if(selectedSizeOptionEl.length && (selectedSizeOptionEl.attr("disabled") !== "disabled")){
					var selectedSizeOptionValue = $(selectedSizeOptionEl).val();
					$form.find("select").val(selectedSizeOptionValue).trigger("change");
				}
			})
		}
		if(e.currentTarget[0].parentElement.closest(".shop-grid-item") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item").classList.contains("quick-shop-active")){
			$(`#${e.currentTarget[0].parentElement.id}`).parents("form").removeClass("dropdown-active")
		}		
		if(e.currentTarget[0].parentElement.closest(".shop-grid-item-v2") !== null && e.currentTarget[0].parentElement.closest(".shop-grid-item-v2").classList.contains("quick-shop-active")){
			$(`#${e.currentTarget[0].parentElement.id}`).parents("form").removeClass("dropdown-active")
		}		
		e.currentTarget[0].closest(".select-wrap").classList.remove("select-open");
	})	
	.on("select2:close", function (e) {
		$("body").removeClass("select-open");
		if($(".quick-buy-form").length){
			$(".quick-buy-form").removeClass("dropdown-active");
		}
		$(`#${e.currentTarget[0].parentElement.id}`).parents("form").removeClass("dropdown-active")
		e.currentTarget[0].closest(".select-wrap").classList.remove("select-open");
	})		
}
//VIEWPORT CHECK
function isVisible(ele, pos) {
	const { top, bottom } = ele.getBoundingClientRect();
	const vHeight = window.innerHeight || document.documentElement.clientHeight;
	var pos;
	if($(window).width() > 767){
		if(ele.hasAttribute("data-trigger")){
			pos = Number(ele.getAttribute("data-trigger"));
		} else {
			pos = 0.85;
		}
	} else {
		if(ele.hasAttribute("data-mobile-trigger")){
			pos = Number(ele.getAttribute("data-mobile-trigger"));
		} else {
			pos = 0.85;
		}
	}
	return (
		(top > 0 || bottom > 0) && top < vHeight * pos //the decimal moves the scroll trigger. (i.e. 0.1 moves the trigger near the bottom. .99 moves the trigger near the top)
	);
}
var elView = document.querySelectorAll(".check-viewport");
function checkVisibility() {
	var o;
	for (o = 0; o < elView.length; ++o) {
		if (isVisible(elView[o])) {
			elView[o].classList.add("in-view");
		}
	}
}
//OVERLAY
if ($(".overlay").length) {
	$(".overlay").fadeOut(300, function () {
		if (elView) {
			if ($(".hero").length) {
				$(".hero .check-viewport").addClass("in-view");
			}
			checkVisibility();
			document.addEventListener("scroll", checkVisibility, { passive: true });
			$(window).on("resize", checkVisibility, { passive: true });
		}
	});
} else {
	// Mobile: Initialize Select2 for drawer selects only
	$(".custom-select").each(function() {
		const $select = $(this);
		const isInDrawer = $select.closest('drawer-ui').length > 0;
		
		// Only initialize Select2 for selects inside drawers on mobile
		if (isInDrawer) {
			const config = {
				minimumResultsForSearch: Infinity,
				dropdownParent: $select.closest('drawer-ui')
			};
			
			$select.select2(config);
		}
	});
	
	if (elView) {
		if ($(".hero").length) {
			$(".hero .check-viewport").addClass("in-view");
		}
		checkVisibility();
		document.addEventListener("scroll", checkVisibility, { passive: true });
	}
}
var lastCartDrawerTrigger = null;

function syncCartDrawerA11yState(isOpen) {
	const cartDrawer = document.querySelector(".slide-out-cart");
	const cartOverlay = document.querySelector(".slide-out-overlay");
	if (cartDrawer) {
		cartDrawer.setAttribute("aria-hidden", isOpen ? "false" : "true");
	}
	if (cartOverlay) {
		cartOverlay.setAttribute("aria-hidden", isOpen ? "false" : "true");
	}
}

function closeCartDrawer() {
	$(".slide-out-cart").fadeOut();
	$(".slide-out-overlay").removeClass("active");
	syncCartDrawerA11yState(false);
	$("html").css("overflow", "auto");
	setTimeout(function () {
		$("html").removeClass("frozen");
		if (window.trapFocus && typeof window.trapFocus.untrap === "function") {
			const cartContainer = document.querySelector(".slide-out-cart");
			if (cartContainer) {
				window.trapFocus.untrap(cartContainer);
			}
		}
		if (lastCartDrawerTrigger && typeof lastCartDrawerTrigger.focus === "function") {
			lastCartDrawerTrigger.focus();
		}
		lastCartDrawerTrigger = null;
	}, 250);
}

function openCartDrawer() {
	const activeElement = document.activeElement;
	if (activeElement && typeof activeElement.focus === "function") {
		lastCartDrawerTrigger = activeElement;
	}
	$(".slide-out-overlay").addClass("active");
	$(".slide-out-cart").css("display", "flex").hide().fadeIn();
	syncCartDrawerA11yState(true);
	$("html").css("overflow", "hidden");
	setTimeout(function () {
		$("html").addClass("frozen");
		if (window.trapFocus && typeof window.trapFocus.trap === "function") {
			const cartContainer = document.querySelector(".slide-out-cart");
			if (cartContainer) {
				window.trapFocus.trap(cartContainer);
			}
		}
	}, 250);
}

$(document).on("keydown.cartDrawer", function (e) {
	if (e.key === "Escape" && $(".slide-out-cart:visible").length) {
		closeCartDrawer();
	}
});

window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;

$(".slide-out-cart .hamburger, .slide-out-cart .mobile-close-cart").on(
	"click",
	function (e) {
		e.stopPropagation();
		closeCartDrawer();
	}
);
//NAVBAR
if ($(".shop-link").length && $(".shop-slide-out").length) {
	$(".shop-link").on("mouseenter click", function () {
		$(".shop-slide-out").css("display", "flex").hide().fadeIn();
	});
}
//CART
$(".open-cart").on("click", function () {
	openCartDrawer();
});
//CLOSE SLIDE OUTS
if($(window).width() > 991){
	$(document).mouseup(function (e) {
		var addButton = $('#add');
		var slideOutCart = $(".slide-out-cart");
		var shopSlideOut = $(".shop-slide-out");
		var quickBuyButton = $(".quick-buy button");
		if ((!addButton.is(e.target) && addButton.has(e.target).length === 0) && (!slideOutCart.is(e.target) && slideOutCart.has(e.target).length === 0)) {
			closeCartDrawer();
		}
		if ((!addButton.is(e.target) && addButton.has(e.target).length === 0) && (shopSlideOut.is(e.target) && shopSlideOut.has(e.target).length === 0)) {
			shopSlideOut.fadeOut()
		}
	});
}
//slide out hover off
if(!isMobile){
	var slideOutInterval = 0;
	$(".page").on("mousemove", function (e) {
		var keepCartOpen = false;
		if(e.target.closest(".collection-group") !== null){
			keepCartOpen = true;
		}
		if ($("#add").length || $(".slide-out-cart").length || $(".shop-slide-out").length) {
			if(keepCartOpen){
				clearInterval(slideOutInterval);
				slideOutInterval = setInterval(function () {
					$(".shop-slide-out").fadeOut()
				}, 15);
			} else {
				clearInterval(slideOutInterval);
				slideOutInterval = setInterval(function () {
					$(".shop-slide-out").fadeOut()
				}, 15);
			}
		}
	});
	if($("#shopify-section-search-dropdown").length){
		$("#shopify-section-search-dropdown").on("mousemove", function (e) {
			clearInterval(slideOutInterval);
			slideOutInterval = setInterval(function () {
				$(".shop-slide-out").fadeOut();
				closeCartDrawer();
			}, 15);
		})
	}
	$(".shop-link, .open-cart").on("mousemove", function () {
		clearInterval(slideOutInterval);
	});
}
//ANNOUNCEMENT BAR ANIMATION
if ($(".announcement-bar").length) {
	//   var lines = $('.announcement-bar .announcement-container div').children().length;
	//   var linesSpeed = parseInt($('.announcement-bar .announcement-container div').attr('data-speed'))
	//   if(lines > 1){
	//     var activeLineIndex = 0;
	//     setTimeout(function() {
	//       setInterval(function(){
	//         if((lines - 1) > activeLineIndex){
	//           activeLineIndex++
	//         } else {
	//           activeLineIndex = 0;
	//         }
	//         $('.announcement-bar .announcement-container div').children().fadeOut(150)
	//         setTimeout(function(){
	//           $('.announcement-bar .announcement-container div').children().eq(activeLineIndex).fadeIn(150)
	//         }, 150);
	//       }, linesSpeed);
	//     }, 1000);
	//   }
	$(".announcement-container").slick({
		fade: true,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: parseInt(
			$(".announcement-container").attr("data-speed")
		),
		pauseOnHover: false,
	});
}
//ARROW LINKS
if ($(".arrow-link").length) {
	$(".arrow-link").each(function () {
		$(this).append(
			`<svg viewBox="0 0 17.092 13.12"xmlns=http://www.w3.org/2000/svg><defs/><g data-name="Group 404"><g data-name="Group 363"fill=none stroke=#241f20 stroke-miterlimit=10><path d="M10.178.356l6.207 6.207-6.207 6.207"data-name="Path 5212"/><path d="M0 6.56h16.385"data-name="Line 119"/></g></g></svg>`
		);
	});
}
//TABS
if ($(".tabs").length) {
	$(".tabs").each(function () {
		var $tabs = $(this).find(".tab-item");
		$(this)
			.find(".tab-item")
			.on("click", function (e) {
				e.preventDefault();
				var $tab = $(this);
				var $tabContent = $tab.parents(".tab-items").next(".tab-content");
				if($tab.siblings(".tab-item").length){
					$tab.siblings(".tab-item").removeClass("active")
				} else {
					$tab.parents(".tab-items").find(".tab-item").removeClass("active");
				}
				$tab.addClass("active");
				if($tab.parent().parent().prev().hasClass("tab-item-nested-children")){
					$tab.parent().parent().prev().parent().siblings().find(".tab-item").removeClass("active")
					$tab.parent().parent().prev(".tab-item-nested-children").addClass("active")
				}
				if(!$tab.hasClass("tab-item-nested-children")){
					var $content = $tab.next().html();
					$tabContent.html($content);
				} else {
					$tab.next().children().eq(0).find(".tab-item").addClass("active")
					var $content = $tab.next().children().eq(0).find(".tab-item").next().html();
					$tabContent.html($content);
				}
				if($(".brand-sizes").length){
					if($(".tab-item[href='#women-underwear']").hasClass("active")){
						$(".brand-sizes").show();
					} else {
						$(".brand-sizes").hide(); 
					}
				}
			});
	});
	if($(".brand-sizes").length){
		$(`a[href="#men"]`).on("click", function(){
			$(".brand-sizes").hide(); 
		})
		$(`a[href="#women"]`).on("click", function(){
			if($(".tab-item[href='#women-underwear']").hasClass("active")){
				$(".brand-sizes").show();
			}
		})
		if(isMobile){

			function adjustBrandSelectWidth() {
				$(".brand-sizes select").each(function() {
					var $select = $(this);
					var $selectedOption = $select.find("option:selected");
			
					// Create a dummy span to measure the text width
					var $dummySpan = $("<span>").text($selectedOption.text()).css({
						"position": "absolute",
						"visibility": "hidden",
						"white-space": "nowrap",
						"font-family": $select.css("font-family"),
						"font-size": $select.css("font-size"),
						"font-weight": $select.css("font-weight")
					});
			
					// Append the dummy span to the body
					$("body").append($dummySpan);
			
					// Set the width of the select based on the span width
					$select.width($dummySpan.width()); // Added 20px for padding
			
					// Remove the dummy span from the DOM
					$dummySpan.remove();
				});
			}
			
			// Initial adjustment
			adjustBrandSelectWidth();
			
			// Adjust on change
			$(".brand-sizes select").on("change", adjustBrandSelectWidth);
			
			
		}
	}
}
//SET SHOP MENU POSITION TO MATCH MAIN MENU POSITION
function setShopNavPos() {
	if ($(".announcement-bar").length) {
		var announcementBarHeight = $(".announcement-bar").outerHeight(true);
		$(".shop-slide-out-top").css("padding-top", announcementBarHeight + 19);
		$(".header").css("top", announcementBarHeight - 3);
	} else {
		$(".header").css("top", 0);
		$(".shop-slide-out-top").css("padding-top", "18px");
	}
}
setShopNavPos();
//ACCORDION
if ($(".accordion").length) {
	$(".accordion").each(function () {
		var $accordion = $(this);
		var $trigger = $(this).children(".accordion-trigger");
		$trigger.on("click", function (e) {
			$accordion.siblings().removeClass("accordion--active");
			if(!$accordion.hasClass("accordion--active")){
				$accordion.addClass("accordion--active");
			} else {
				$accordion.removeClass("accordion--active");
			}
			if ($(".impact-report").length) {
				$trigger.nextAll().slideDown();
				$trigger
					.find(".accordion-toggle")
					.children()
					.addClass("active-toggle");
			} else {
				$trigger.nextAll().slideToggle();
				$trigger
					.find(".accordion-toggle")
					.children()
					.toggleClass("active-toggle");
			}
			if ($(".set-includes-content").length) {
				var img = $trigger.find("img").attr("src");
				var title = $trigger.find(".font-serif").html();
				var content = "<img src='" + img + "' /><p>" + title + "</p>";
			}
			$(".set-includes-content").html(content);
			//slide down others
			$accordion
				.parent()
				.find(".accordion-trigger")
				.not($trigger)
				.nextAll()
				.slideUp();
			$accordion
				.parent()
				.find(".accordion-trigger")
				.not($trigger)
				.find(".accordion-toggle")
				.children()
				.removeClass("active-toggle");
		});
	});
}
//HOME
if ($(".featured-main-group").length) {
	$(".featured-main-group .featured-group-title").removeClass("active");
	$(".featured-main-group .featured-group-title").eq(0).addClass("active");
	var activeGroup = $(".featured-group").eq(0);
	var activeDescription = activeGroup
		.find(".featured-group-description")
		.html();
	var activeImage = activeGroup.find(".featured-group-image").attr("src");
	var activeImageUrl = activeGroup.find(".featured-group-image-url").attr("href");
	$(".featured-main-group .featured-group-description").html(
		activeDescription
	);
	$(".featured-main-group .featured-group-main-image").attr(
		"src",
		activeImage
	);
	$(".featured-main-group .featured-group-main-image-url").attr(
		"href",
		activeImageUrl
	);
	$(".featured-main-group .featured-group-title").on(
		"mouseenter click",
		function () {
			var index = $(this).index();
			activeGroup = $(".featured-group").eq(index);
			activeDescription = activeGroup
				.find(".featured-group-description")
				.html();
			activeImage = activeGroup.find(".featured-group-image").attr("src");
			activeImageUrl = activeGroup.find(".featured-group-image-url").attr("href");
			$(".featured-main-group .featured-group-description").html(
				activeDescription
			);
			$(".featured-main-group .featured-group-main-image").attr(
				"src",
				activeImage
			);
			$(".featured-main-group .featured-group-main-image-url").attr(
				"href",
				activeImageUrl
			);
			$(".featured-group-title").removeClass("active");
			$(this).addClass("active");
		}
	);
}
if ($(".home-bestsellers").length) {
	$(".home-bestsellers .group-link").on("click", function (e) {
		e.preventDefault();
		var index = $(this).index();
		var activeGroup = $(".home-bestsellers .shop-grid-3").eq(index);
		$(".home-bestsellers .group-link, .home-bestsellers .shop-grid-3").removeClass("active");
		$(".bestsellers-buttons").children("div").addClass("hide");
		$(".bestsellers-buttons.hide").children("div").eq(index).removeClass("hide");
		$(".bestsellers-buttons.landscape-hide").children("div").eq(index).removeClass("hide");
		activeGroup.addClass("active");
		$(this).addClass("active");
	});
}
if ($(".home-info-carousel").length) {
	$(".home-info-carousel").slick({
		centerMode: true,
		centerPadding: "150px",
		focusOnSelect: true,
		cssEase: "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
		speed: 425,
		responsive: [
			{
				breakpoint: 860,
				settings: {
					centerMode: false,
					dots: true,
				},
			},
		],
	});
	$(".home-info-carousel .arrow-link").each(function () {
		var arrowColor = $(this).attr("data-color");
		$(this).css("color", arrowColor);
		$(this).find("g").css("stroke", arrowColor);
	});
}
function titleCase(str) {
	str = str.toLowerCase().split(" ");
	for (var i = 0; i < str.length; i++) {
		str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
	}
	return str.join(" ");
}
if ($(".pdp-hero-gallery").length) {

		
		$(".pdp-hero-main-image").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: ".pdp-hero-gallery",
			infinite: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						dots: true,
					},
				},
			],
		});
		var slides;
		var initialActiveSlide = 0;
		$(".pdp-hero-gallery").on("init", function (event, slick) {
			$(document).ready(function(){
				slides = slick.$slides;
				var activeColor = $(".swatch-wrap.active")
					.find("input")
					.attr("data-color");
				var nextSlide;
				slides.map(function (slide) {
					if (
						slides[slide].dataset.orientation &&
						slides[slide].dataset.color === activeColor &&
						slides[slide].dataset.orientation.includes(activeColor)
					) {
						initialActiveSlide = slide;
						console.log(slides[slide].dataset.orientation);
						if (slides[slide].dataset.orientation.includes("back")) {
							initialActiveSlide = slide - 1;
						}
						// grabs the slide before since it'll land on the "back view" instead of previous slide that's the "front view"
					}
				});
			});		
		});
		var imagesCount = parseInt($(".pdp-hero-right").attr("data-images"));
		if (imagesCount < 6) {
			$(".pdp-hero-gallery").addClass("transform-none");
		}
		$(".pdp-hero-gallery")
			.slick({
				slidesToShow: imagesCount < 6 ? imagesCount : 4,
				slidesToScroll: 1,
				asNavFor: ".pdp-hero-main-image",
				arrows: true,
				focusOnSelect: true,
				infinite: true,
			})
			.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
				var newSlide = slides[nextSlide];
				if (newSlide) {
					var swatchTitle = newSlide.dataset.title;
					var swatchHandle = newSlide.dataset.color;
				}
				if ($(".swatch").length && !$(".master-product").length) {
					if ($(".swatch." + swatchHandle).length) {
						$(".swatch-radio").prop("checked", false);
						$(".swatch-radio." + swatchHandle).prop("checked", true);
						$(".pdp-color").text(titleCase(swatchTitle));
						$(".pdp-colors .swatch-wrap").removeClass("active");
						$(".swatch-radio." + swatchHandle)
							.parents(".swatch-wrap")
							.addClass("active");
						$("#product-select-option-0")
							.val(titleCase(swatchTitle))
							.trigger("change"); // changes the shopify variant
					}
				}
			});
			$(document).ready(function(){
				$(".pdp-hero-gallery").slick("slickGoTo", initialActiveSlide);
			});		
		if ($(".swatch-radio").length) {
			$(".pdp-colors .swatch-wrap.active .swatch-radio").prop(
				"checked",
				true
			);
			$(".pdp-colors .swatch-radio").on("change", function () {
				var nextSlide;
				var swatchColor = $(this).attr("data-color");
				var swatchTitle = $(this).attr("data-title");
				// console.log('front-' + swatchColor)
				var filteredSlides = slides.map(function (slide) {
					if (
						slides[slide].dataset.orientation.includes(
							"front-" + swatchColor
						) ||
						slides[slide].dataset.orientation.includes("back-" + swatchColor)
					) {
						nextSlide = slide;
						$(".pdp-hero-gallery").slick("slickGoTo", nextSlide);
						// grabs the slide before since it'll land on the "back view" instead of previous slide that's the "front view"
					}
				});
				// product upsells
				// if ($(".product-upsells .upsell.upsell-" + swatchColor).length) {
				// 	$(".product-upsells .upsell").removeClass("active").hide(0);
				// 	$(".product-upsells .upsell.upsell-" + swatchColor)
				// 		.addClass("active")
				// 		.show(0);
				// } else {
				// 	$(".product-upsells .upsell").removeClass("active").hide(0);
				// 	$(".product-upsells .upsell.first-upsell")
				// 		.addClass("active")
				// 		.show(0);
				// }
			});
			$(document).ready(function(){
				// if($(".upsell").length){
				// 	$(".upsell").removeClass("active")
				// 	if($(".upsell[data-color-handle='" + $(".pdp-colors .swatch-wrap.active input").attr("data-color") + "']").length){
				// 		$(".upsell-" + $(".pdp-colors .swatch-wrap.active input").attr("data-color")).addClass("active")
				// 	} else {
				// 		$(".product-upsells .upsell.first-upsell")
				// 		.addClass("active")
				// 		.show(0);
				// 	}
				// }				
			})
		}
		if ($(".gallery-trigger").length) {
			$(".gallery-trigger input").on("change", function () {
				var nextSlide;
				var triggerOption = $(this).attr("data-title").toLowerCase();
				// console.log('front-' + swatchColor)
				var filteredSlides = slides.map(function (slide) {
					if (
						slides[slide].dataset.orientation.includes(triggerOption) ||
						slides[slide].dataset.orientation.includes(triggerOption)
					) {
						nextSlide = slide;
						$(".pdp-hero-gallery").slick("slickGoTo", nextSlide);
						// grabs the slide before since it'll land on the "back view" instead of previous slide that's the "front view"
					}
				});
			});
		}
		if ($("#product-select").children().length > 1) {
			$(".pdp-hero-gallery .pdp-hero-gallery-slide").on(
				"touchend click",
				function () {
					var thevalue = $(this).attr("data-title");
					$("#product-select-option-0")
						.val(titleCase(thevalue))
						.trigger("change"); // changes the shopify variant
				}
			);
		}

}

//PDP QUANTITY
if ($(".pdp-quantity").length) {
	$(".pdp-quantity").val(1);
	$(".pdp-plus").on("click", function () {
		var qty = $(".pdp-quantity").val();
		var newQty = qty++;
		$(".pdp-quantity").val(qty++);
		var event = new CustomEvent('pdpQuantityUpdated', {
			detail: {
				quantity: $(".pdp-quantity").val()
			}
		});
		document.dispatchEvent(event);		
	});
	$(".pdp-minus").on("click", function () {
		var qty = parseInt($(".pdp-quantity").val(), 10) || 1;
		if (qty > 1) {
			qty--;
			$(".pdp-quantity").val(qty);
			var event = new CustomEvent('pdpQuantityUpdated', {
				detail: {
					quantity: qty
				}
			});
			document.dispatchEvent(event);
		}
	});
	$(".pdp-quantity").on("change", function () {
		var qty = parseInt($(this).val(), 10) || 1;
		if (qty < 1) {
			qty = 1;
			$(this).val(1);
		}
		var event = new CustomEvent('pdpQuantityUpdated', {
			detail: {
				quantity: qty
			}
		});
		document.dispatchEvent(event);
	});
}
if ($(".pdp-tabbed-sliders").length) {
	function destroySlider(el) {
		/*el.slick('destroy');*/
		el.slick("refresh");
	}
	function reInitSlider(el) {
		el.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
		});
	}
	$(".pdp-tabbed-sliders .tabbed-slider").each(function () {
		var $slider = $(this);
		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});
	$(".pdp-tabbed-sliders .fit-tabbed-slider").each(function () {
		var $slider = $(this);
		$slider
			.slick({
				slidesToScroll: 1,
				fade: true,
				arrows: true,
			})
			.on(
				"beforeChange",
				function (event, slick, currentSlide, nextSlide) {
					$slider
						.next()
						.find(".fit-tabbed-slider-nav-item")
						.removeClass("active");
					$slider
						.next()
						.find(".fit-tabbed-slider-nav-item")
						.eq(nextSlide)
						.addClass("active");
				}
			);
		$slider
			.next()
			.find(".fit-tabbed-slider-nav-item")
			.each(function (index) {
				var $navItem = $(this);
				$navItem.on("click", function () {
					$slider.slick("slickGoTo", index);
					$navItem.addClass("active");
				});
			});
	});
	$(window).on("resize", function () {
		$(
			".pdp-tabbed-sliders .tabbed-slider, .pdp-tabbed-sliders .fit-tabbed-slider"
		).each(function () {
			var $slider = $(this);
			destroySlider($slider);
			//reInitSlider($slider)
		});
	});
	function toggleSliders(index) {
		var $slider = $(".pdp-tabbed-sliders .tabbed-slider-content:not(.hide)")
			.children()
			.eq(index);
		$(".pdp-tabbed-sliders .tabbed-slider-content").children().css({
			position: "absolute",
			left: "-9999999px",
		});
		$slider.css({
			position: "static",
		});
	}
	toggleSliders(0);
	$(".pdp-tabbed-sliders .tabbed-slider-items a").on("click", function (e) {
		e.preventDefault();
		$(".pdp-tabbed-sliders .tabbed-slider-items a").removeClass("active");
		$(this).addClass("active");
		var index = $(this).parent().index();
		toggleSliders(index);
		// $(".fit-tabbed-slider").slick("refresh");
		if ($(".tabbed-slider-description").length) {
			$(".tabbed-slider-description").removeClass("active");
			$(".tabbed-slider-description").eq(index).addClass("active");
		}
		if ($(".pdp-tabbed-sliders .tabbed-slider").length) {
			destroySlider($(".pdp-tabbed-sliders .tabbed-slider"));
			//reInitSlider($('.pdp-tabbed-sliders .tabbed-slider'))
		}
		if ($(".pdp-tabbed-sliders .fit-tabbed-slider").length) {
			destroySlider($(".pdp-tabbed-sliders .fit-tabbed-slider"));
			//reInitSlider($('.pdp-tabbed-sliders .fit-tabbed-slider'))
		}
	});
}
//PDP Size Guide
if ($(".open-size-guide").length) {
	$(".open-size-guide").on("click", function (e) {
		e.preventDefault();
		$(".size-guide").addClass("active");
		$(".slide-out-overlay").addClass("active");
	});
	$(".mobile-close-size-guide, .slide-out-overlay").on("click", function () {
		$(".size-guide").removeClass("active");
		$(".slide-out-overlay").removeClass("active");
	});
}
//PDP Models trigger
if ($("#models").length) {
	$("#models-trigger, #models-mobile-trigger").on("click", function (e) {
		e.preventDefault();
		$("html,body").animate({ scrollTop: $("#models").offset().top });
	});
}
//OPEN GORGIAS MODAL
if ($("#gorgias-trigger").length) {
	$("#gorgias-trigger, #gorgias-mobile-trigger").on("click", function (e) {
		e.preventDefault();
		GorgiasChat.open();
	});
}
//PDP GALLERY
if ($(".pdp-gallery-mobile").length) {
	$(".pdp-gallery-mobile").each(function(){
		$(this).slick()
	})
}
//PDP Info slider
if ($(".pdp-info-slider").length) {
	$(".info-slider").slick({
		arrows: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
				},
			},
		],
	});
}
//FEATURED PRODUCTS
if ($(".featured-products:has(.bestsellers[data-slides])").length) {
	$(".featured-products").each(function(){
		var slidesToShow = Number($(this).find(".bestsellers").attr("data-slides"));
		$(this).find(".bestsellers").slick({
			infinite: false,
			slidesToShow: slidesToShow,
			prevArrow: $(this).find(".featured-products-prev:not(.featured-products-prev-mobile)"),
			nextArrow: $(this).find(".featured-products-next:not(.featured-products-next-mobile)"),
			responsive: [
				{
				  breakpoint: 860,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				  }
				}
			  ]			
		});
		$(this).find(".bestsellers-mobile").slick({
			infinite: false,
			slidesToShow: slidesToShow,
			prevArrow: $(this).find(".featured-products-prev-mobile"),
			nextArrow: $(this).find(".featured-products-next-mobile"),
			responsive: [
				{
				  breakpoint: 860,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				  }
				}
			  ]			
		});
	})
}
if($(".testimonials-carousel").length){
	$(".testimonials-carousel").slick({
		dots: true,
		arrows: false,
		fade: true
	});
}
//STARTER SET LANDING
if ($(".starter-set-landing").length) {
	$(".starter-set-skip-down").on("click", function () {
		if($(this).closest(".shopify-section").length){
			if($(this).closest(".shopify-section").next(".shopify-section").length){
				$("html, body").animate({
					scrollTop: $(window.innerWidth < 992) ? $(this).closest(".shopify-section").next(".shopify-section").offset().top - $(".navbar").outerHeight(true) : $(this).closest(".shopify-section").next(".shopify-section").offset().top,
				});
			}
		} else {
			$("html, body").animate({
				scrollTop: $(".starter-set-hero").offset().top,
			});
		}
	});
}
//FITTING ROOM STYLES TOGGLE
if ($(".fitting-styles-toggles").length) {
	$(".fitting-styles-toggles a").on("click", function (e) {
		e.preventDefault();
		$(
			".fitting-styles-toggles a, .tabbed-slider-items .tab-item"
		).removeClass("active");
		$(this).addClass("active");
		var activeIndex = $(this).parent().index() - 1;
		$(".tabbed-slider-items, .tabbed-slider-content").addClass("hide");
		$(".tabbed-slider-items").eq(activeIndex).removeClass("hide");
		$(".tabbed-slider-content").eq(activeIndex).removeClass("hide");
		$(".tabbed-slider-content").children().css({
			position: "absolute",
			left: "-9999999px",
		});
		$(".tabbed-slider-content:not(.hide)").children().eq(0).css({
			position: "static",
		});
		$(".tabbed-slider-items li:first-child .tab-item").addClass("active");
		$(".fit-tabbed-slider").slick("refresh");
	});
}
//FITTING ROOM MEASURE
if ($(".fitting-room-measure").length) {
	$(".fitting-room-measure .tab-items a:not(.tab-item-nested-children)").on("click", function (e) {
		e.preventDefault();
		var id = $(this).attr("href");
		if($(id).length){
			// var $index = $(this).parent().index()
			var $tabParent = $(this).parents("[role='tabpanel']")
			$tabParent.find(".measure-visual").children().addClass("hide")
			$tabParent.find(".measure-visual .flex-column").each(function () {
				var $this = $(this);
				$this.find(".measure-visual-description").addClass("hide");
				$this.find(".measure-visual-marker").removeClass("active");
				$this.find(".measure-visual-description").eq(0).removeClass("hide");
				$this.find(".measure-visual-marker").eq(0).addClass("active");
			});
			$(id).removeClass("hide");
		}
	});
	$(".fitting-room-measure .tab-items a.tab-item-nested-children").on("click", function (e) {
		e.preventDefault()
		$(this).next().find(".tab-item").eq(0).trigger("click");
	});

	$(".fitting-room-measure .measure-visual-marker").each(function () {
		var $marker = $(this);
		$marker.on("click", function () {
			var $this = $(this);
			var index = $this.index();
			if (!$this.hasClass("active")) {
				$this
					.parents(".flex-column")
					.find(".measure-visual-marker")
					.removeClass("active");
				$this.addClass("active");
				$this
					.parents(".flex-column")
					.find(".measure-visual-description")
					.addClass("hide");
				$this
					.parents(".flex-column")
					.children(".bg-sky")
					.children(".measure-visual-description")
					.eq(index-1)
					.removeClass("hide");
			}
		});
	});
	$(".measure-tooltip-btn").on("click", function () {
		$(".measure-tooltip").removeClass("active");
		$(this).parent().next().addClass("active");
	});
	$(document).mouseup(function (e) {
		var toolTip = $(".measure-tooltip");
		if (!toolTip.is(e.target) && toolTip.has(e.target).length === 0) {
			toolTip.removeClass("active");
		}
	});
}

var getOffsetTop = function (elem) {
	// Set our distance placeholder
	var distance = 0;
	// Loop up the DOM
	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}
	// Return our distance
	return distance < 0 ? 0 : distance;
};

//FAQs
function checkActiveNavSection(el) {
	var elHeight = $(el).height();
	var elTop =
		$(el)[0].getBoundingClientRect().top +
		$(window)["scrollTop"]() -
		$(".header").height();
	var elBottom =
		$(el)[0].getBoundingClientRect().bottom +
		$(window)["scrollTop"]() -
		$(".header").height();
	if ($("#shopify-section-seams-steps").length) {
		elTop =
			$(el)[0].getBoundingClientRect().top +
			$(window)["scrollTop"]() -
			$(".header").height() -
			150;
		elBottom =
			$(el)[0].getBoundingClientRect().bottom +
			$(window)["scrollTop"]() -
			$(".header").height() -
			150;
	}
	var secondElTop = $(".sidebar-nav")[0].getBoundingClientRect().top;
	if ($(window).scrollTop() < secondElTop) {
		$(".sidebar-link").eq(0).addClass("active");
	} else if (
		$(window).scrollTop() > elTop &&
		$(window).scrollTop() < elBottom
	) {
		$(".sidebar-nav a[href='" + el + "']").addClass("active");
	} else {
		$(".sidebar-nav a[href='" + el + "']").removeClass("active");
	}

	if (!$(".sidebar-link.active").length) {
		$(".sidebar-link").eq(0).addClass("active");
	}
}
$(".sidebar-nav a").on("click", function (e) {
	e.preventDefault();
	var href = $(this).attr("href");
	$("html, body").animate({ scrollTop: $(href).offset().top - 10 });
	// $('.sidebar-link').removeClass('active')
	// $(this).addClass('active')
});
//BEHIND THE SEAMS
if ($(".seams-skip-down").length) {
	$(".seams-skip-down").on("click", function () {
		$("html, body").animate({
			scrollTop: $("#shopify-section-seams-hero").next().offset().top,
		});
	});
}
//RECYCLE
var isStepInView = function (elem) {
	var bounding = elem.getBoundingClientRect();
	return (
		bounding.top &&
		bounding.bottom <= window.innerHeight - bounding.bottom + 350
	);
};
function checkStepVisibility() {
	if ($(".recycle-step").length) {
		document
			.querySelectorAll(".recycle-step")
			.forEach(function (el, index) {
				if (isStepInView(el)) {
					// Do something
					el.classList.add("in-view");
					var num = parseInt($(el).text().split(".")[0]);
					$(".recycle-step-graphic").addClass("hide");
					$(".recycle-step-graphic")
						.eq(num - 1)
						.removeClass("hide");
				} else {
					el.classList.remove("in-view");
				}
			});
	}
}
//FITTING ROOM
function checkActiveFittingRoomSection(el) {
	if($(el).length){
		var elHeight = $(el).height();
		var elTop =
			$(el)[0].getBoundingClientRect().top +
			$(window)["scrollTop"]() -
			$(".header").height() -
			100;
		var elBottom =
			$(el)[0].getBoundingClientRect().bottom +
			$(window)["scrollTop"]() -
			$(".header").height() -
			100;
		if ($(window).scrollTop() > elTop && $(window).scrollTop() < elBottom) {
			$(".explore a[href='" + el + "']").addClass("active");
		} else {
			$(".explore a[href='" + el + "']").removeClass("active");
		}
	}
}
$(".explore a").on("click", function (e) {
	e.preventDefault();
	var href = $(this).attr("href");
	$("html, body").animate({ scrollTop: $(href).offset().top });
});
function fittingRoom() {
	if ($(".explore").length) {
		if ($(window).scrollTop() > 100) {
			$(".explore").fadeIn();
		} else {
			$(".explore").fadeOut();
		}
		$(".explore a").each(function () {
			var href = $(this).attr("href");
			if(href){
				checkActiveFittingRoomSection(href);
			}
		});
	}
}
//RESIZER
function resizeWindow() {
	//DETECT MOBILE
	if (
		/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
	) {
		isMobile = true;
		$("html").addClass("k-mod-touch");
	} else if ($(window).width() < 991) {
		isMobile = true;
		$("html").addClass("k-mod-touch");
	} else {
		isMobile = false;
		$("html").removeClass("k-mod-touch");
	}
	//HEADER HEIGHT 
	if($(".announcement-bar").length){
		if($(".navbar-dropdown").length && $(".navbar-dropdown").height() > 1){
			document.documentElement.style.setProperty('--header-height', $(".announcement-bar").outerHeight(true) + $(".navbar").outerHeight(true) - 13 + "px");
		} else {
			document.documentElement.style.setProperty('--header-height', $(".announcement-bar").outerHeight(true) + $(".header").outerHeight(true) - 13 + "px");
		}
		document.documentElement.style.setProperty('--announcement-height', $(".announcement-bar").outerHeight(true) + "px");
	} else {
		if($(".navbar-dropdown").length && $(".navbar-dropdown").height() > 1){
			document.documentElement.style.setProperty('--header-height', $(".navbar").outerHeight(true) - 13 + "px");
		} else {
			document.documentElement.style.setProperty('--header-height', $(".header").outerHeight(true) - 13 + "px");
		}
		document.documentElement.style.setProperty('--announcement-height', 0);
	}
	//HOME
	if ($(".home-info-carousel").length) {
		setTimeout(function () {
			var carouselHeight = $(".home-info-carousel .slick-track").height();
			$(".info-carousel-item").css("height", carouselHeight);
		}, 1500);
	}
	//BLOG
	if ($(".blog-grid").length) {
		var headerHeight = $(".header").outerHeight(true);
		var wHeight = $(window).height();
		if ($(".announcement-bar").length) {
			var announcementBarHeight =
				$(".announcement-bar").outerHeight(true);
			headerHeight = headerHeight + announcementBarHeight;
		}
		$(".featured-post").css({
			"max-height": wHeight - headerHeight - 28,
		});
	}
}
$(document).ready(function () {
	resizeWindow();
});
$(window).on("resize", resizeWindow);
//SCROLLZ
function scrollWindow() {
	var wScroll = $(window).scrollTop();
	if (wScroll > 40) {
		scrolledPastThreshold = true;
	} else {
		scrolledPastThreshold = false;
	}
	//NAVBAR ANIMATION
	if (scrolledPastThreshold) {
		$(".navbar").addClass("active");
	} else {
		$(".navbar").removeClass("active");
	}
	$(".navbar")
		.on("mouseenter", function () {
			$(".navbar").addClass("active");
		})
		.on("mouseleave", function () {
			if (!scrolledPastThreshold) {
				$(".navbar").removeClass("active");
			}
		});
	//GRAMS
	if ($(".pdp-follow-us").length) {
		var gramsTop = $(".pdp-follow-us").offset().top;
		$(".pdp-follow-us .gram")
			.eq(0)
			.css({
				transform: "translate(0px, -" + wScroll / 50 + "px)",
			});
		$(".pdp-follow-us .gram")
			.eq(1)
			.css({
				transform: "translate(0px, -" + wScroll / 12 + "px)",
			});
		$(".pdp-follow-us .gram")
			.eq(2)
			.css({
				transform: "translate(0px, -" + wScroll / 50 + "px)",
			});
		$(".pdp-follow-us .gram")
			.eq(3)
			.css({
				transform: "translate(0px, -" + wScroll / 12 + "px)",
			});
	}
	//HOME CHAT WINDOW
	if ($(".home").length) {
		if ($("#chat-button").length) {
			if (scrolledPastThreshold) {
				$("#chat-button").fadeIn();
			} else {
				$("#chat-button").fadeOut();
			}
		}
	}
	//FAQs
	if ($(".sidebar-nav").length) {
		$(".sidebar-nav a").each(function () {
			var href = $(this).attr("href");
			checkActiveNavSection(href);
		});
	}
	//FITTING ROOM
	fittingRoom();
	//RECYCLE
	checkStepVisibility();
}
$(document).ready(function () {
	scrollWindow();
});
document.addEventListener("scroll", scrollWindow, { passive: true });

//OVERLAY
if ($(".overlay").length) {
	$(".overlay").fadeOut(300, function () {
		if (elView) {
			if ($(".hero").length) {
				$(".hero .check-viewport").addClass("in-view");
			}
			checkVisibility();
			document.addEventListener("scroll", checkVisibility, { passive: true });
		}
	});
} else {
	if (elView) {
		if ($(".hero").length) {
			$(".hero .check-viewport").addClass("in-view");
		}
		checkVisibility();
		document.addEventListener("scroll", checkVisibility, { passive: true });
	}
}

/**
 * In .dual-image-collection grids, match the height of each
 * .shop-grid-large-image-bottom to its sibling .shop-grid-item__content
 * so the image spacer aligns with the product info. Desktop only (>992px).
 */
function syncDualImageBottomHeights() {
	var isDesktop = window.matchMedia('(min-width: 992px)').matches;

	document.querySelectorAll('.dual-image-collection .shop-grid-large-image').forEach(function(imageEl) {
		var spacer = imageEl.querySelector('.shop-grid-large-image-bottom');
		if (!spacer) return;

		if (!isDesktop) {
			spacer.style.flex = '';
			return;
		}

		var sibling = imageEl.nextElementSibling;
		if (!sibling) return;
		var content = sibling.querySelector('.shop-grid-item__content');
		if (content) {
			var contentHeight = content.offsetHeight;
			spacer.style.flex = '0 0 ' + contentHeight + 'px';
		}
	});
}

$(document).ready(syncDualImageBottomHeights);
window.addEventListener('resize', syncDualImageBottomHeights);
document.addEventListener('filters:updated', syncDualImageBottomHeights);

/**
 * Certification badge tooltips: hover handles pointer devices via CSS;
 * this makes a tap toggle the tooltip on touch devices. Tapping the same
 * badge again, another badge, or anywhere else dismisses it.
 */
document.addEventListener('click', function (e) {
	if (!window.matchMedia('(hover: none)').matches) return;
	var badge = e.target.closest('.product-cert-badge');
	document.querySelectorAll('.product-cert-badge.tooltip-open').forEach(function (open) {
		if (open !== badge) open.classList.remove('tooltip-open');
	});
	if (badge && badge.querySelector('.product-cert-badge__tooltip')) {
		badge.classList.toggle('tooltip-open');
	}
});

var ComparisonTable = class extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector('.table__inner');
    if (!this.inner) return;

    // The scroll-driven divider is only needed when the highlighted column
    // is the one pinned directly beside the frozen first column.
    if (!this.inner.querySelector('.table__header-item[data-highlighted="true"]:nth-child(2)')) {
      return;
    }

    this.radius =
      parseFloat(getComputedStyle(this.inner).getPropertyValue('--table-highlight-radius')) || 12;
    this._ticking = false;
    this._onScroll = this._onScroll.bind(this);
    this.inner.addEventListener('scroll', this._onScroll, { passive: true });
    this._update();
  }

  disconnectedCallback() {
    if (this.inner && this._onScroll) {
      this.inner.removeEventListener('scroll', this._onScroll);
    }
  }

  _onScroll() {
    if (this._ticking) return;
    this._ticking = true;
    requestAnimationFrame(() => {
      this._update();
      this._ticking = false;
    });
  }

  _update() {
    // Inset follows the highlighted column's circular corner (not a straight
    // line) so the frozen divider hugs the rounded corner with no gap. At the
    // frozen edge the box's top sits at: r - sqrt(r^2 - (r - scrollLeft)^2).
    var r = this.radius;
    var s = Math.min(this.inner.scrollLeft, r);
    var inset = r - Math.sqrt(r * r - (r - s) * (r - s));
    this.inner.style.setProperty('--frozen-divider-inset', inset + 'px');
  }
}

if (!window.customElements.get("comparison-table")) {
window.customElements.define("comparison-table", ComparisonTable);
}
